import Component, {
  productMetaData,
} from "~/route-containers/product.container";
import { productLoader } from "~/loaders/product.loader";
export { productMetaData as meta };

export { productLoader as loader };

export default Component;
